export default "__VITE_ASSET__X23f7cEm__"